import { getRegion } from 'utils/Region';

export const getClaroAdsKey = state => {
  const isClaroAdsKeyInApa = state?.metadata?.cv_advertising_config;
  const parseClaroAdsKey = isClaroAdsKeyInApa
    ? JSON.parse(isClaroAdsKeyInApa)
    : false;
  const claroAdsKeyByRegion = parseClaroAdsKey?.[getRegion()]
    ? parseClaroAdsKey?.[getRegion()]?.enable
    : parseClaroAdsKey?.default?.enable || false;
  return claroAdsKeyByRegion;
};
